import React from 'react';
import { ArrowRight } from 'lucide-react';
import { navigateToHomeSection } from '../utils/navigation';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    navigateToHomeSection(sectionId);
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-950 to-black">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(37,99,235,0.25),transparent_60%)]"></div>
        <div className="absolute inset-0 opacity-[0.12]" style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 46px, rgba(59,130,246,0.42) 46px, rgba(59,130,246,0.42) 47px),
            repeating-linear-gradient(90deg, transparent, transparent 46px, rgba(59,130,246,0.42) 46px, rgba(59,130,246,0.42) 47px)
          `,
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="hero-fade-in">
          <span className="inline-block text-xs uppercase tracking-wider text-blue-400 border border-blue-500/20 bg-blue-500/10 px-4 py-1.5 rounded-full mb-6">
            Premium Infrastructure Solutions
          </span>

          <h1 className="text-4xl md:text-6xl font-semibold leading-tight tracking-tight text-white max-w-4xl mx-auto">
            <span className="block">Intelligent Automation &</span>
            <span className="block bg-gradient-to-r from-blue-400 to-blue-500 bg-clip-text text-transparent">
              LV Infrastructure Solutions
            </span>
          </h1>

          <p className="mt-6 text-gray-400 text-base md:text-lg font-normal">
            17+ Years | 1500+ Projects | Trusted Across Residential, Commercial & Industrial Projects
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-md text-white font-medium transition-all duration-300 shadow-lg shadow-blue-500/20"
            >
              Request Consultation
              <ArrowRight className="inline-block ml-2" size={18} />
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="border border-blue-500/40 text-blue-400 px-6 py-3 rounded-md hover:bg-blue-500/10 transition-all duration-300"
            >
              View Projects
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
